import React from "react";
import { Paper, Box, Typography, Stack, Chip, IconButton, Divider } from "@mui/material";

import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { formatLastContact } from "../../utils/formatLastContact";

function chipSx() {
    return { fontWeight: 800, border: "1px solid var(--border)", bgcolor: "var(--branco)" };
}

function priorityChip(priority) {
    if (priority === "Alta") return <Chip label="Alta" color="error" size="small" />;
    if (priority === "Média") return <Chip label="Média" color="warning" size="small" />;
    return <Chip label="Baixa" size="small" sx={chipSx()} />;
}

function statusChip(status) {
    if (status === "Sem resposta") return <Chip label={status} color="error" size="small" />;
    if (status === "Em conversa") return <Chip label={status} color="primary" size="small" />;
    if (status === "Aguardando") return <Chip label={status} color="warning" size="small" />;
    if (status === "Fechado") return <Chip label={status} color="success" size="small" />;
    return <Chip label={status} size="small" sx={chipSx()} />;
}

export default function LeadsCards({ leads }) {
    return (
        <Stack spacing={1.5}>
            {leads.map((l) => (
                <Paper
                    key={l.id}
                    elevation={0}
                    sx={{
                        p: 2,
                        borderRadius: 3,
                        border: "1px solid var(--border)",
                        bgcolor: "var(--branco)",
                    }}
                >
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography sx={{ fontWeight: 900 }} noWrap>
                                {l.name}
                            </Typography>
                            <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13 }} noWrap>
                                {l.phone}
                            </Typography>
                        </Box>

                        <Stack direction="row" spacing={0.8}>
                            {priorityChip(l.priority)}
                            {statusChip(l.status)}
                        </Stack>
                    </Stack>

                    <Divider sx={{ my: 1.5 }} />

                    <Stack direction="row" spacing={1} flexWrap="wrap">
                        <Chip label={`Etapa: ${l.stage}`} size="small" sx={chipSx()} />
                        <Chip label={`Resp: ${l.owner}`} size="small" sx={chipSx()} />
                        <Chip label={`Último: ${formatLastContact(l.lastMessageAt)}`} size="small" sx={chipSx()} />
                    </Stack>

                    <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ mt: 1.5 }}>
                        <IconButton size="small" onClick={() => window.location.assign(`/admin/conversas?open=${l.id}`)}>
                            <ChatOutlinedIcon fontSize="small" />
                        </IconButton>

                        <IconButton size="small" onClick={() => alert("Abrir agenda (futuro)")}>
                            <EventAvailableOutlinedIcon fontSize="small" />
                        </IconButton>

                        <IconButton size="small" onClick={() => alert("Abrir detalhes (futuro)")}>
                            <InfoOutlinedIcon fontSize="small" />
                        </IconButton>
                    </Stack>
                </Paper>
            ))}
        </Stack>
    );
}